import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const CoachingActionPlanDashboard = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        // Get Teamlead Coaching Dashboard Search Data
        getTeamleadCoachingDashboardSearch: builder.query({
            query: ({
                employeeNumber,
                year,
                month,
            }: {
                employeeNumber: string;
                year: number;
                month: number;
            }) => ({
                url: constants.GET_TEAMLEAD_COACHING_DASHBOARD_SEARCH,
                params: { employeeNumber, year, month },
            }),
        }),

        // Get Teamlead Coaching Dashboard Skills Search Data
        getTeamleadCoachingDashboardSkillsSearch: builder.query({
            query: ({
                employeeNumber,
                year,
                month,
            }: {
                employeeNumber: string;
                year: number;
                month: number;
            }) => ({
                url: constants.GET_TEAMLEAD_COACHING_DASHBOARD_SKILLS_SEARCH,
                params: { employeeNumber, year, month },
            }),
        }),
    }),
});

export const {
    useGetTeamleadCoachingDashboardSearchQuery,
    useGetTeamleadCoachingDashboardSkillsSearchQuery,
} = CoachingActionPlanDashboard;
